import React, { useState } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook

export const AdminCreateStaticStrengthTemplate = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate(); // Initialize navigate

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [photoPreview, setPhotoPreview] = useState(null); // To store the preview URL
  const [photo, setPhoto] = useState(null);
  const [status, setStatus] = useState("DRAFT"); // New status field

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handlePhotoChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setPhoto(file);
      const previewUrl = URL.createObjectURL(file);
      setPhotoPreview(previewUrl);
    }
  };

  const handleSave = async () => {
    setIsLoading(true);
    setError("");
    setSuccess("");
  
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);
      formData.append("price", price);
      formData.append("status", status); // Add status to form data
      if (photo) {
        formData.append("photo", photo); // Append the photo to FormData
      }
  
      const response = await fetch(`${API_URL.POST_STATIC_STRENGTH_WORKOUT_TEMPLATE}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${staff.token}`, // No "Content-Type" when using FormData; it sets automatically
        },
        body: formData, // Use FormData to send both text and file data
      });
  
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Failed to create template");
      }
  
      const data = await response.json();
      setSuccess("Template created successfully!");
      setTitle("");
      setDescription("");
      setPrice("");
      setPhoto(null);
      setPhotoPreview(null);
      setStatus("DRAFT");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="flex h-screen">
      <StaffSideMenu />

      <div className="flex-1 p-6 bg-gray-100 pt-16">
        {/* Go Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 right-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
        >
          Go Back
        </button>

        {error && (
          <div className="bg-red-100 text-red-500 p-3 rounded mb-4">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-100 text-green-500 p-3 rounded mb-4">
            {success}
          </div>
        )}

        <h1 className="text-2xl font-bold mb-4">Static Strength Workout Template</h1>

        <div className="bg-white p-4 rounded shadow">
          <div className="mb-4">
            <label className="block font-bold mb-2">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter title"
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-2">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter description"
            ></textarea>
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-2">Price</label>
            <input
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter price"
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-2">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full p-2 border rounded"
            >
              <option value="DRAFT">DRAFT</option>
              <option value="PUBLISHED">PUBLISHED</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-2">Upload Photo</label>
            <input type="file" onChange={handlePhotoChange} className="w-full" />
            {photoPreview && (
              <img
                src={photoPreview}
                alt="Preview"
                className="mt-4 max-w-full h-auto rounded shadow"
                style={{ width: '30%', borderRadius: '8px', border: '1px solid #ccc' }}
              />
            )}
          </div>

          <button
            onClick={handleSave}
            className={`px-4 py-2 mt-4 bg-blue-500 text-white rounded hover:bg-blue-600 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};
